<template>
	<div v-if="data" class="invite_wrap">
		<div class="basic_wrap">
			<div class="red_top_bg">
				<div class="back_left" @click="$router.back()"></div>
				<div class="big_tit">{{$t('income.title2')}}</div>
				<div class="top_right" @click="$router.push('/trading')">
					<van-icon name="bars" size="25"/>
				</div>
			</div>
			<div class="head-tabs">
			    <a href="#/vip" class="tab-item active">{{$t('income.title2')}}</a>
			    <a href="#/item" class="tab-item">{{$t('income.title3')}}</a>
			    <a href="#/order" class="tab-item">{{$t('income.investr')}}</a>
			</div>
			<div class="user_top bgdeep">
				
				<!-- <div class="user_detail">
					<div class="user_header">
						<img :src="data.user_icon">
					</div>
					<span>
						{{data.mobile}}
						({{data.vip_name}})
					</span>
				</div> -->
				<div class="user_balance">
					<p>{{$t('vip2.tinvest')}}</p>
					<p>{{data.baoku_money}} {{utils_moneyMark()}}</p>
				</div>
				<div class="user_team">
					<p>{{$t('vip2.level')}} : <span>{{data.vip_name}}</span> </p>
					<p>{{$t('vip2.recharge')}} : <span>{{data.all_lixi}}  {{utils_moneyMark()}}</span></p>
				</div>
				
			</div>
			<div class="nopermit">
				<p>
					<router-link to="/invest2">
						<div class="basic_btn">{{$t('vip2.levelup')}}</div>
					</router-link>
					<router-link to="/myteam">
						<div class="basic_btn">{{$t('vip2.bonusd')}}</div>
					</router-link>
				</p>
				<!-- <p>{{$t('team.nopermit')}}</p>
				<p>{{$t('team.nopermit2')}}</p> -->
			</div>
			<div class="table-wrap" v-if="vips">
				<div class="vip-item bgdeep"  v-for="(it,i) in vips" @click="$router.push('/invest2')">
					<img :src="data.user_icon" loading="lazy" alt="" class="vip-img">
				    <div class="vip-info">
				        <div class="vip-name">Daily：{{it.rate}} %</div>
				        <div class="vip-desc">
				            <span >Deposit：</span>
				            <span class="text-bold text-df" >{{it.value}}</span>
				        </div>
				    </div>
				    <div class="action-box">
				        <span class="i-icon i-icon-arrow-right">
							<van-icon name="exchange" size="23" color="#fff"/>
				        </span>
				    </div>
				    <div class="absoulte-level">VIP{{i}}</div>
				    <div class="mask" v-if="parseFloat(data.vip.rate)<parseFloat(it.rate)">
				        <div class="lock-box">
				           <van-icon name="lock" size="25" color="#fff"/>
				        </div>
				    </div>
				</div>
			</div>
			<!-- <div class="table-wrap">
			    <table class="ui-table">
			        <thead>
			        <tr>
			            <th class="pl">{{$t('vip2.elevel')}}</th>
			            <th>{{$t('vip2.pcount')}}</th>
			            <th>{{$t('vip2.irates')}}</th>
			        </tr>
			        </thead>
			        <tbody v-if="vips">
						<tr v-for="(it,i) in vips">
							<td class="pl">VIP{{i}}</td>
							<td>{{it.value}}</td>
							<td>{{it.rate}} %</td>
						</tr>
			        </tbody>
			    </table>
			</div> -->
		</div>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	import bsHeader from '../../components/bsHeader.vue';
	import Vue from 'vue';
	import {
		Empty,
		Icon
	} from 'vant';
	import Clipboard from "v-clipboard";
	Vue.use(Empty).use(Clipboard).use(Icon);
	export default {
		name: "vip",
		data() {
			return {
				data:null,
				vips:null
			};
		},
		components: {
			bsHeader
		},
		created() {
			this.$parent.footer('item');
		},
		mounted() {
			
			this.start();
		},
		methods: {
			start() {
				Fetch("/user/basicinfo").then((r) => {
					this.data = r.data;
					this.vips = r.data.vips;
				});
			}
		}
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		height: 44px;
		// background: url(../images/user/tg_bg.png) no-repeat center center;
		background-size: 100% 100%;
		position: relative;
		.big_tit {
			position: absolute;
		}
		.back_right{
			position: absolute;
			top: 3px;
			right: 3px;
		}
		.introduce {
		    height: 25px;
		    display: flex;
		    justify-content: center;
		    align-items: center;
		    font-size: 18px;
		    line-height: 25px;
		    color: #FFFFFF;
		    margin-top: 20px;
		
		    .line {
		        width: 36px;
		        height: 10px;
		    }
		
		    .tit {
		        margin: 0 12px;
		        font-weight: bold;
		    }
		
		    .left_line {
		        background: url(../images/user/left_icon.png) no-repeat center center;
		        background-size: 100% 100%;
		    }
		
		    .right_line {
		        background: url(../images/user/right_icon.png) no-repeat center center;
		        background-size: 100% 100%;
		    }
		}
		.award_tip {
		    font-size: 14px;
		    line-height: 20px;
		    color: rgba(255, 255, 255, 0.8);
		    text-align: left;
		    margin: 3px auto 0 auto;
			margin-left: 15%;
		}
	}
	.user_top{
		width: 95%;
		position: relative;
		margin: 0 auto;
		border-radius: 5px;
		padding: 6vw 0;
		.user_detail{
			display: flex;
			justify-content: space-between;
			text-align: center;
			.user_header {
				width: 70px;
				height: 70px;
				overflow: hidden;
				border-radius: 50%;
				position: absolute;
				top: -35px;
				img {
					width: 100%;
					height: 100%;
				}
			}
			span{
				margin-left: 80px;
				font-size: 16px;
				font-weight: bold;
			}
		}
		.user_balance{
			text-align: center;
			p:nth-child(1){
				font-size: 14px;
			}
			p:nth-child(2){
				margin-top: 10px;
				font-weight: bold;
				font-size: 18px;
				color: #282828;
			}
		}
		.user_team{
			display: flex;
			justify-content: space-between;
			text-align: center;
			p{
				width: 50%;
				margin-top: 20px;
				font-size: 14px;
			}
			p:nth-child(1){
				border-right: 1px #999 solid;
			}
			span{
				color: #282828;
				font-weight: bold;
			}
			
		}
		.user_share{
			display: flex;
			justify-content: space-between;
			margin: 20px 0 0px 0;
			font-size: 14px;
			p:nth-child(1){
				width: 70%;
				margin-left: 20px;
				text-overflow: ellipsis;
				white-space: nowrap;
				overflow: hidden;
				line-height: 28px;
			}
			p:nth-child(2){
				text-align: center;
				width: 20%;
				background: #e7544d;
				color: #FFFFFF;
				padding: 6px 0px;
				border-radius: 5px;
				margin-right: 15px;
			}
		}
	}
	.tabs{
		display: flex;
		justify-content: space-between;
		text-align: center;
		margin-top: -70px;
		width: 88%;
		margin-left: 6%;
		p{
			width: 28%;
			padding: 5px;
			border-radius: 5px;
		}
		.active{
			background: #f61a44;
			color: #FFFFFF;
		}
	}
	.list{
		margin-top: 10px;
		width: 96%;
		margin-left: 2%;
		background: #FFFFFF;
		border-radius: 5px;
		.item {
		    height: 52px;
		    line-height: 52px;
		    width: 314px;
		    margin: 0 auto;
		    display: flex;
		    justify-content: flex-start;
		    align-items: center;
		    border-bottom: 1px solid #E3E4E5;
			p:nth-child(1){
		        font-size: 13px;
		        color: #000;
		        margin-left: 8px;
		    }
			p:nth-child(2){
		        flex: 1;
		        margin-left: auto;
		        text-align: right;
		        font-size: 12px;
		        color: rgba(0, 0, 0, 0.4);
		    }
		}
	}
	.mask {
	    position: fixed;
	    top: 0;
	    right: 0;
	    left: 0;
	    bottom: 0;
	    background-color: rgba(0, 0, 0, 0.6);
	    z-index: 30;
	
	    .share_inner {
	        width: 230px;
			height: 280px;
	        position: absolute;
	        top: 60%;
	        left: 0;
	        right: 0;
	        margin: -232px auto 0 auto;
	        background: url(../images/user/share_bg.png) no-repeat center center;
	        background-size: 100% 100%;
			.earn{
				font-size: 32px;
				position: absolute;
				top: 112px;
				color: #fff;
				font-weight: bold;
				width: 100%;
				text-align: center;
			}
			.invite{
				font-size: 20px;
				position: absolute;
				top: 158px;
				color: #fff;
				width: 100%;
				text-align: center;
			}
			
	    }
	
	    .white_bg {
	        width: 160px;
			height: 160px;
	        background-color: #FFFFFF;
	        position: absolute;
	        top: 30px;
			left: 35px;
	        display: flex;
	        justify-content: center;
	        align-items: center;
	
	        img {
	            width: 143px;
	            height: 143px;
	        }
	    }
	
	    .basic_btn {
	        position: absolute;
	        left: 0;
	        right: 0;
	        margin: 0 auto;
	        top: 175px;
			height: 40px;
			line-height: 40px;
			font-size: 12px;
			width: 90%;
	    }
	}
	.nopermit{
		text-align: center;
		font-size: 12px;
		line-height: 25px;
		margin: 15px;
		p{
			display: flex;
			a{
				text-decoration: none;
				width: 50%;
				text-align: center;
				.basic_btn{
					width: 70%;
					margin: 0 auto;
					height: 35px;
					font-size: 12px;
					line-height: 35px;
				}
			}
		}
	}
	
	
	.scrollBox {
		width: 96%;
		margin-left: 2%;
		position: relative;
	}
	
	.table-wrap {
	    position: relative;
	    overflow: hidden;
		margin: 10px;
		border-radius: 10px;
	}
	.ui-table {
	    margin-bottom: -1px;
	    background: #fff7f1;
	}
	.ui-table {
	    background: #fff;
	    font-size: 12px;
	}
	.ui-table {
	    width: 100%;
	    border-collapse: collapse;
	    border-spacing: 0;
	    text-align: center;
		th {
		    height: 40px;
		    background: #ffeee2;
		    font-size: 14px;
		    color: #6c3b23;
		    text-align: center;
			font-weight: 400;
		}
		 .pl {
		    padding-left: 15px;
		}
		td {
		    height: 40px;
		    color: #6d6d6d;
		    border-bottom: 1px solid #ffe8de;
		    text-align: center;
		}
	}
	.vip-item {
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: justify;
	    -webkit-justify-content: space-between;
	    -ms-flex-pack: justify;
	    justify-content: space-between;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	    padding: 12px 16px;
	    box-sizing: border-box;
	    border-radius: 8px;
	    background-color: #fff;
	    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
	    margin-bottom: 12px;
	    position: relative;
	    overflow: hidden;
	}
	.vip-item .vip-img {
	    width: 80px;
	    height: 80px;
		border-radius: 3vw;
	}
	.vip-item .vip-info {
	    text-align: left;
		width: 45vw;
	}
	.vip-item .vip-info .vip-name {
	    font-size: 16px;
	    font-weight: 700;
	    margin-bottom: 12px;
	}
	.vip-item .vip-info .vip-desc {
	    font-size: 12px;
	}
	
	.vip-item .action-box {
	    padding: 6px 16px 4px 16px;
	    text-align: center;
	    font-size: 14px;
	    color:#fff;
	    border-radius: 40px;
	    cursor: pointer;
		background: #282828;
	}
	
	.vip-item .absoulte-level {
	    position: absolute;
	    background: #f5f5f5;
	    color: #0c7f9e;
	    padding: 24px 16px 8px 16px;
	    border-radius: 50%;
	    top: -20px;
	    left: 50%;
	    font-size: 12px;
	}
	.vip-item .mask{
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	    -webkit-justify-content: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	}
	.vip-item .mask {
	    position: absolute;
	    top: 0;
	    left: 0;
	    width: 100%;
	    height: 100%;
	    background: rgba(0,0,0,.4);
	    border-radius: 8px;
	    z-index: 2;
	}
	
	.vip-item .mask .lock-box,.index-wrap2 .vip-item .mask{
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	    -webkit-justify-content: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	}
	
	.vip-item .mask .lock-box {
	    background: hsla(0,0%,100%,.4);
	    width: 50px;
	    height: 50px;
	    border-radius: 50%;
	}
	.vip-item .mask .lock-box, .index-wrap2 .vip-item .mask{
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		-webkit-align-items: center;
		-ms-flex-align: center;
		align-items: center;
	}
</style>
